import * as React from 'react';
import CoachingConstants from 'coaching/CoachingConstants';
import Image from 'components/Image';
import Link from 'components/Link';
import Text from 'components/Text';
import NavigationListCoachingStreamItem from './NavigationListCoachingStreamItem';
import { NavigationList_me_navigationSections_items_CoachingStream } from 'queries/__generated__/NavigationList';
import CoachingAvatar from 'assets/images/coaching/coaching_avatar.svg';

import './styles/NavigationListCoachingSection.scss';

export type CoachingSectionKey = 'coachingCoachStreams' | 'coachingParticipantStreams';

export type Props = {
  sectionKey: CoachingSectionKey;
  items: NavigationList_me_navigationSections_items_CoachingStream[];
};

export default function NavigationListCoachingSection(props: Props) {
  const mapKeyToLink = {
    coachingCoachStreams: CoachingConstants.COACHING_AVAILABILITY_ROUTE,
    coachingParticipantStreams: CoachingConstants.COACHING_HOME_ROUTE,
  };
  const mapKeyToLabel = {
    coachingCoachStreams: 'Coach schedule',
    coachingParticipantStreams: 'Coaching dashboard',
  };

  return (
    <section className="NavigationList-section">
      <li className="NavigationListCoachingSection-header">
        <Link
          data-test="navigation-coaching-section-header-link"
          color="inherit"
          activeClassName="active"
          to={mapKeyToLink[props.sectionKey]}
          className="NavigationListCoachingSection-header-link">
          <div className="NavigationListCoachingSection-header-container">
            <Image
              src={CoachingAvatar}
              width={16}
              className="NavigationListCoachingSection-header-avatar"
            />
            <Text size="xsmall" color="pitch" className="NavigationListCoachingSection-header-name">
              {mapKeyToLabel[props.sectionKey]}
            </Text>
          </div>
        </Link>
      </li>
      {props.items?.map(i => (
        <NavigationListCoachingStreamItem key={i.uuid} coachingStream={i} />
      ))}
    </section>
  );
}
